import {newStepValue} from '../../../../services/flowBuilder/utils/constants';

export const menuForm = {
    json: {
        menu: {
            menuType: 'menuForm',
            menuHeader: '',
            imageRef: '',
            input: {
                isPrivateVariable: true,
            },
            menuParams: {
                subHeader: '',
                showPageResults: false,
                invalidInputText: '',
                pages: []
            },
        },
        type: 'menu',
        next: newStepValue,
    },
    paths: [
        'menu.imageRef',
        'menu.menuHeader',
        'menu.input.isPrivateVariable',
        'menu.menuParams.subHeader',
        'menu.menuParams.showPageResults',
        'menu.menuParams.invalidInputText',
        'next',
    ],
    groups: [
        {
            Parameters: [
                'menu.imageRef',
                'menu.menuHeader',
                'menu.input.isPrivateVariable',
                'menu.menuParams.subHeader',
                'menu.menuParams.showPageResults',
                'menu.menuParams.invalidInputText',
            ],
        },
        {
            Logic: ['next'],
        },
    ],
    layout: {
        menuHeader: {
            type: 'input',
            label: 'Menu Header',
            placeholder: 'Name the menu header',
            attributes: {
                optional: true
            }
        },
        subHeader: {
            type: 'input',
            label: 'Menu Sub Header',
            placeholder: 'Name the menu sub header',
            attributes: {
                optional: true
            }
        },
        invalidInputText: {
            type: 'input',
            label: 'Invalid Input Text',
            placeholder: 'Enter Invalid Input Text',
            attributes: {
                optional: true
            }
        },
        imageRef: {
            type: 'image',
            label: '',
            validators: {
                required: false,
            },
        },
        isPrivateVariable: {
            type: 'checkbox-single',
            label: 'Multiple Selection',
        },
        showPageResults: {
            type: 'checkbox-single',
            label: 'Multiple Selection',
        },
        next: {
            type: 'next',
            label: 'Point to',
            validators: {
                optionSelected: true,
            },
        },
    }
};
